"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
var react_youtube_1 = __importDefault(require("react-youtube"));
var youtube_video_props_1 = require("./youtube-video.props");
require("./youtube-video.styles.css");
var YoutubeVideo = function (props) {
    var bem = (0, hook_use_bem_classes_1.default)('rwc-youtube-video');
    var intervalRef = (0, react_1.useRef)();
    var _a = (0, react_1.useState)(undefined), player = _a[0], setPlayer = _a[1];
    var is50Triggered = false;
    var is90Triggered = false;
    var onPlayProgress = function () {
        var _a, _b, _c, _d;
        var viewedPercentage = player.getCurrentTime() / player.getDuration();
        if (((_a = props.events) === null || _a === void 0 ? void 0 : _a.onPlay90Percent) &&
            viewedPercentage >= 0.9 &&
            !is90Triggered) {
            (_b = props.events) === null || _b === void 0 ? void 0 : _b.onPlay90Percent();
            is90Triggered = true;
        }
        else if (((_c = props.events) === null || _c === void 0 ? void 0 : _c.onPlay50Percent) &&
            viewedPercentage >= 0.5 &&
            !is50Triggered) {
            (_d = props.events) === null || _d === void 0 ? void 0 : _d.onPlay50Percent();
            is50Triggered = true;
        }
        else if (viewedPercentage < 0.5) {
            is50Triggered = false;
            is90Triggered = false;
        }
    };
    var handleStateChange = function (e) {
        var _a, _b, _c, _d;
        if (!player)
            setPlayer(e.target);
        if (((_a = props.events) === null || _a === void 0 ? void 0 : _a.onPlay) && e.data === youtube_video_props_1.YTPlayerState.PLAYING) {
            (_b = props.events) === null || _b === void 0 ? void 0 : _b.onPlay();
            if (((_c = props.events) === null || _c === void 0 ? void 0 : _c.onPlay50Percent) || ((_d = props.events) === null || _d === void 0 ? void 0 : _d.onPlay90Percent)) {
                intervalRef.current = window.setInterval(onPlayProgress, 1000);
            }
        }
        else if (intervalRef.current) {
            window.clearInterval(intervalRef.current);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: bem(), id: props.youtubeId }, { children: [(0, jsx_runtime_1.jsx)(react_youtube_1.default, { videoId: props.youtubeId, title: props.filename || 'Embedded youtube', onStateChange: function (e) { return handleStateChange(e); } }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "rwc-youtube-video-filename item-detail-header" }, { children: props.filename }))] })));
};
exports.default = YoutubeVideo;
//# sourceMappingURL=youtube-video.component.js.map